import React from 'react'
import { Releve } from '../account_model'
import CardOp from './CardOp'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../../../../styles'

const useStyle = makeStyles((theme) => ({
    ...styles(theme),
    listContainer: {
        marginTop: 20,
        display: 'flex',
        flexDirection: 'column'
    }
}))

interface AcceptingProps {
    releves: Array<Releve>,
    setOpenPayment: (amount: number, facture: string, piece_numero: string) => void,
    paymentDisabled: boolean
}

type ListOpProps = AcceptingProps

const ListOp: React.FC<ListOpProps> = (
    {
        releves,
        setOpenPayment,
        paymentDisabled
    }
) => {
    const classes = useStyle()
    return (
        <div className={classes.listContainer}>
            {
                releves.map((statement: Releve) => (
                    <CardOp
                        paymentDisabled={paymentDisabled}
                        operation={statement}
                        setOpenPayment={setOpenPayment}
                    />
                ))
            }
        </div>
    )
}
export default ListOp
